// extracted by mini-css-extract-plugin
export var animationContainer = "_gi-0";
export var asteriskIcon = "_gi-8";
export var conversationLeftSection = "_gi-4";
export var conversationListItem = "_gi-3";
export var conversationMiddleSection = "_gi-5";
export var conversationRightSection = "_gi-6";
export var detailsContent = "_gi-1";
export var listContainer = "_gi-7";
export var modalContent = "_gi-2";